import { createStore } from "vuex";
import Cookies from "js-cookie"; // Import js-cookie
import i18n from "@/plugins/LanguageComponent.js";
import { decrypt } from "@/utils/cryptoHelper";

const modules = {};

const i18nPlugin = (store) => {
    store.i18n = i18n; // Sisipkan i18n ke Vuex instance
};

// Auto-import semua file modul kecuali `index.js`
const requireModule = require.context(".", false, /^((?!index).)*\.js$/);
requireModule.keys().forEach((fileName) => {
    const moduleName = fileName.replace(/(\.\/|\.js)/g, ""); // Hapus ./ dan .js
    modules[moduleName] = requireModule(fileName).default; // Impor modul
});

// Buat store
const store = createStore({
    modules,
    plugins: [i18nPlugin],
});

// Inisialisasi token dari localStorage jika ada
const token = localStorage.getItem("token");
if (token) {
    // console.log("tokennn", token);
    store.commit("user/setToken", token); // Set token ke state
    store.commit("user/setAuthenticated", true);
}

const savedUser = localStorage.getItem("user");
try {
    const decryptedUser = savedUser ? decrypt(savedUser) : null;
    const parsedUser = decryptedUser ? JSON.parse(decryptedUser) : null;
    store.commit("user/setUser", { data: parsedUser }); // Gunakan mutation `setUser`
} catch (error) {
    console.warn("Invalid user data in localStorage. Clearing...");
    localStorage.removeItem("user");
    store.commit("user/setUser", null); // Set user ke null
}

// Inisialisasi language dari cookies
const savedLanguage = Cookies.get("language");
if (savedLanguage) {
    store.commit("language/setLanguage", savedLanguage); // Set language ke state
}

const isGuestEncrypted = localStorage.getItem("isGuest");
if (isGuestEncrypted) {
    const isGuest = decrypt(isGuestEncrypted);
    store.commit("user/setGuest", isGuest === "true"); // Set nilai ke Vuex state setelah dekripsi
} else {
    store.commit("user/setGuest", true);
    console.warn("isGuest not found in localStorage. Defaulting to guest mode.");
}

export default store;
